import { ICookieStorageData, ICognitoStorage } from 'amazon-cognito-identity-js';
import { AwsCognitoOAuthOpts } from './aws-cognito-oauth-opts';
import { Auth0OAuthOpts } from './auth0-oauth-opts';

export interface AuthOptions {
    userPoolId?: string,
    userPoolWebClientId?: string,
    identityPoolId?: string,
    region?: string,
    mandatorySignIn?: boolean
    cookieStorage?: ICookieStorageData,
    oauth?: AwsCognitoOAuthOpts | Auth0OAuthOpts,
    refreshHandlers?: object,
    storage?: ICognitoStorage,
    authenticationFlowType?: string,
    identityPoolRegion?: string
}